import { render } from "./SendMessage.vue?vue&type=template&id=9c90988c"
import script from "./SendMessage.vue?vue&type=script&lang=js"
export * from "./SendMessage.vue?vue&type=script&lang=js"

import "./SendMessage.vue?vue&type=style&index=0&id=9c90988c&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__